import "core-js/modules/es.date.to-string.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import QueryString from 'qs';
import { PricingType } from '../common/PropTypes'; // utils

import { buildDataForPushEventStreamData, getDistanceFromTop, makeTransactionId, pushEventStreamData, pushGtmData, generateLinkWithAddedParams, generateAffiliateLink, replaceSpacesWithDashes } from '@jelly/utils'; // Import Components

import Modal from '../Modal';
import RfqWidget from '../RfqWidget';
import { SiteConfigContext } from '../SiteConfigProvider';
import { Button } from '@jelly/ui';
import { PhoneIcon } from '../svgs/PhoneIcon';
var DEFAULT_AFFILIATE_TEXT = 'visit site';
var DEFAULT_WIDGET_TEXT = 'compare quotes';

var ButtonsContainer = _styled("div", {
  target: "e1q42nr00",
  label: "ButtonsContainer"
})("display:flex;flex-direction:column;align-items:center;width:100%;max-width:180px;", function (_ref) {
  var theme = _ref.theme;
  return theme.MQ.M;
}, "{align-items:flex-start;}button:not(:first-child),a:not(:first-child){margin-top:1rem;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function createHiddenInputForRingpool(key, value) {
  var hasExistingInput = document.getElementsByName(key).length;

  if (!hasExistingInput && key && value) {
    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute('value', value); //append to form element that you want

    document.body.appendChild(input);
  }
}

function loadRingpoolScript(callback) {
  var existingScript = document.getElementById('ringpoolScript');

  if (!existingScript) {
    var script = document.createElement('script');
    script.src = "".concat(process.env.GATSBY_CF_RINGCENTER_BASE_URL, "/Resources/JS/autoringpool-latest-v4.js");
    script.id = 'ringpoolScript';
    document.body.appendChild(script);

    script.onload = function () {
      if (callback) {
        callback();
      }
    };
  }

  if (existingScript && callback) {
    callback();
  }
}

function useQt(_ref2) {
  var affId = _ref2.affId,
      offerId = _ref2.offerId;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      offer = _useState2[0],
      setOffer = _useState2[1];

  useEffect(function () {
    var getOfferData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url, params, response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new URL("".concat(process.env.GATSBY_RFQ_API_BASE_URL, "/v2/qt/offer"));
                params = {
                  affId: affId,
                  offerId: offerId
                };
                url.search = new URLSearchParams(params).toString();
                _context.prev = 3;
                _context.next = 6;
                return fetch(url);

              case 6:
                response = _context.sent;
                _context.next = 9;
                return response.json();

              case 9:
                data = _context.sent;
                setOffer(data);

                if (data.ringpoolId && data.ringpoolDefaultPhone) {
                  createHiddenInputForRingpool('cf_attr1', affId);
                  createHiddenInputForRingpool('cf_attr2', document.location.href);
                  setTimeout(function () {
                    loadRingpoolScript();
                  }, 500);
                }

                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                console.log(_context.t0);
                setOffer({});

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14]]);
      }));

      return function getOfferData() {
        return _ref3.apply(this, arguments);
      };
    }();

    if (affId && offerId) {
      getOfferData();
    }
  }, [affId, offerId]);
  return offer;
}
/**
 * This is the Monetization Button Component
 * Baked in logic to display more than one button if supplied by BE
 *
 * @param {categoryWidgetId} props.categoryWidgetId :: widget id declared on the category level
 * if this does not exist then button falls back on categoryWidgetId
 */


export var MonetizationButton = function MonetizationButton(props) {
  var buttonLimit = props.buttonLimit,
      categoryWidgetId = props.categoryWidgetId,
      _props$fallbackCompon = props.fallbackComponent,
      fallbackComponent = _props$fallbackCompon === void 0 ? null : _props$fallbackCompon,
      pricing = props.pricing,
      _props$rank = props.rank,
      rank = _props$rank === void 0 ? '' : _props$rank,
      _props$sectionType = props.sectionType,
      sectionType = _props$sectionType === void 0 ? '' : _props$sectionType,
      _props$serviceName = props.serviceName,
      serviceName = _props$serviceName === void 0 ? '' : _props$serviceName,
      tabTitle = props.tabTitle,
      _props$templateType = props.templateType,
      templateType = _props$templateType === void 0 ? '' : _props$templateType,
      type = props.type;
  var affiliateLink = generateAffiliateLink(pricing);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showRfqModal = _useState4[0],
      setShowRfqModal = _useState4[1];

  var _QueryString$parse = QueryString.parse(affiliateLink === null || affiliateLink === void 0 ? void 0 : affiliateLink.split('?')[1]),
      offerId = _QueryString$parse.offer_id,
      affId = _QueryString$parse.aff_id;

  var _useQt = useQt({
    affId: affId,
    offerId: offerId
  }),
      ringpoolDefaultPhone = _useQt.ringpoolDefaultPhone,
      ringpoolId = _useQt.ringpoolId,
      isCapped = _useQt.isCapped;

  var _useContext = useContext(SiteConfigContext),
      SITE_HOST = _useContext.siteConstants.SITE_HOST;

  var routerLocation = useLocation();

  var handleCtaClick = function handleCtaClick(e, buttonType, link) {
    e.preventDefault();

    if (buttonType === 'affiliate' && !link) {
      return console.warn("Missing ".concat(serviceName, " affiliate button link"));
    }

    var bdcTransactionId = makeTransactionId();
    var bodyHeight = document.documentElement.scrollHeight;
    var buttonHeight = getDistanceFromTop(e.target);
    var buttonPosition = Math.round(buttonHeight / bodyHeight * 100);
    pushGtmData({
      event: 'click.buyButton',
      merchant: serviceName,
      placement: 'bestPickCard',
      position: "".concat(buttonPosition, "%"),
      slug: location.href,
      //eslint-disable-line
      transactionId: bdcTransactionId
    });
    pushEventStreamData(buildDataForPushEventStreamData(window.location, e.currentTarget, serviceName, buttonPosition)); // external redirect with noopener protection - https://mathiasbynens.github.io/rel-noopener/

    if (buttonType === 'affiliate') {
      var linkToOpen = "".concat(link.replace(/TX-ID-VALUE/g, bdcTransactionId));
      var newWindow = window.open();
      newWindow.opener = null;
      newWindow.location = linkToOpen;
    } else {
      setShowRfqModal(true);
    }
  };

  var setUniqueButtonId = function setUniqueButtonId(text) {
    return replaceSpacesWithDashes("".concat(templateType, "_").concat(serviceName, "_").concat(sectionType, "_").concat(text));
  };

  var widgetCategoryId = categoryWidgetId;

  if (pricing) {
    var _pricing$widget;

    if (pricing !== null && pricing !== void 0 && (_pricing$widget = pricing.widget) !== null && _pricing$widget !== void 0 && _pricing$widget.isExclusive) {
      widgetCategoryId = pricing.widget.id;
    } else {
      widgetCategoryId = categoryWidgetId || pricing.widgetId;
    }
  }

  var generateWidgetButton = function generateWidgetButton(_ref4) {
    var _ref4$buttonText = _ref4.buttonText,
        buttonText = _ref4$buttonText === void 0 ? DEFAULT_WIDGET_TEXT : _ref4$buttonText,
        _ref4$inverseButton = _ref4.inverseButton,
        inverseButton = _ref4$inverseButton === void 0 ? false : _ref4$inverseButton;
    var buttonType = 'widget';
    return /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      id: setUniqueButtonId(buttonText),
      onClick: function onClick(e) {
        return handleCtaClick(e, buttonType);
      },
      type: "button",
      variant: inverseButton ? 'secondary' : 'primary'
    }, buttonText);
  };

  var generateRingpoolPhoneButton = function generateRingpoolPhoneButton() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';

    if (!(ringpoolDefaultPhone && ringpoolId)) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      href: "tel:".concat(ringpoolDefaultPhone),
      ringpoolid: ringpoolId,
      placeholder: ringpoolDefaultPhone,
      type: "button",
      variant: variant
    }, /*#__PURE__*/React.createElement(PhoneIcon, {
      height: "20px",
      width: "20px"
    }), " \xA0", ringpoolDefaultPhone);
  };

  var generateAffiliateButton = function generateAffiliateButton(_ref5) {
    var _ref5$buttonText = _ref5.buttonText,
        buttonText = _ref5$buttonText === void 0 ? DEFAULT_AFFILIATE_TEXT : _ref5$buttonText,
        _ref5$inverseButton = _ref5.inverseButton,
        inverseButton = _ref5$inverseButton === void 0 ? false : _ref5$inverseButton,
        link = _ref5.link;

    if (isCapped) {
      return null;
    }

    var buttonType = 'affiliate';
    var affiliateLinkCheck = generateLinkWithAddedParams({
      clientLocation: "".concat(SITE_HOST).concat(routerLocation.pathname),
      link: link,
      rank: rank,
      type: type,
      tabTitle: tabTitle
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      className: "monetization-button",
      id: setUniqueButtonId(buttonText),
      href: affiliateLinkCheck,
      rel: "sponsored nofollow noopener",
      onClick: function onClick(e) {
        return handleCtaClick(e, buttonType, affiliateLinkCheck);
      },
      variant: inverseButton || ringpoolDefaultPhone ? 'secondary' : 'primary'
    }, buttonText));
  };

  var generateDefaultWidgetButton = function generateDefaultWidgetButton() {
    return widgetCategoryId ? generateWidgetButton({}) : null;
  };

  var getButtonList = function getButtonList() {
    var buttonArray = [];

    var _ref6 = pricing || {},
        affiliate = _ref6.affiliate,
        selected = _ref6.selected,
        widget = _ref6.widget;

    switch (selected) {
      case 'affiliate':
        if (isCapped || !affiliate) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateRingpoolPhoneButton());
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink
          }));
        }

        break;

      case 'affiliate-widget':
        if (!affiliate) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateRingpoolPhoneButton());
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink
          }));

          if (widget) {
            buttonArray.push(generateWidgetButton({
              buttonText: widget.cta,
              inverseButton: !isCapped
            }));
          }
        }

        break;

      case 'widget':
        buttonArray.push(!widget ? generateDefaultWidgetButton() : generateWidgetButton({
          buttonText: widget.cta
        }));
        break;

      case 'widget-affiliate':
        if (!widget) {
          buttonArray.push(generateDefaultWidgetButton());
        } else {
          buttonArray.push(generateWidgetButton({
            buttonText: widget.cta
          }));
          buttonArray.push(generateRingpoolPhoneButton('secondary'));
          buttonArray.push(generateAffiliateButton({
            buttonText: affiliate.cta,
            link: affiliateLink,
            inverseButton: true
          }));
        }

        break;

      default:
        buttonArray.push(generateDefaultWidgetButton());
        break;
    } // clean out all the nulls and undefined


    buttonArray = buttonArray.filter(function (item) {
      return !(item === null || item === undefined);
    }); // if there are no monetization buttons render the fallback component if there is one

    if (!buttonArray.length) {
      return fallbackComponent;
    } // if a buttonLimit was passed (like from bestpicks) trim the buttonArrray down


    if (buttonLimit) {
      buttonArray = buttonArray.slice(0, buttonLimit);
    }

    return buttonArray;
  };

  var buttonList = getButtonList();

  if (!buttonList || !buttonList.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isModalVisible: showRfqModal,
    setIsModalVisible: setShowRfqModal,
    onRequestClose: function onRequestClose() {
      return setShowRfqModal(false);
    },
    closeIconPadding: '10px'
  }, /*#__PURE__*/React.createElement(RfqWidget, {
    widgetCategoryId: widgetCategoryId
  })), /*#__PURE__*/React.createElement(ButtonsContainer, null, buttonList.map(function (button, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, " ", button, " ");
  })));
};